/*
    Basic app related functionality goes here.
*/

frappe.provide("servicesuite");
frappe.provide("servicesuite.controller");
